<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>Employee Clearance Approval</h1>
      <v-row>
        <v-col cols="12" xs="12" sm="6" md="3" class="classPadding">
          <v-select
            :items="statuses"
            item-text="text"
            item-value="value"
            label="ECF Status"
            v-model="status"
            class="classPadding"
          ></v-select>
        </v-col>
        <v-col
          cols="12"
          xs="12"
          sm="6"
          md="3"
          offset-md="3"
          class="classPadding"
        >
          <v-text-field
            v-model="search"
            append-outer-icon="mdi-magnify"
            label="Search"
            class="classPadding"
            @click:append-outer="triggerSearch"
            @keyup.enter="triggerSearch"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="3" class="classPadding">
          <v-select
            :items="searchByItems"
            item-text="text"
            item-value="value"
            v-model="searchBy"
            class="classPadding"
          ></v-select>
        </v-col>
      </v-row>
      <v-data-table :items="items" :headers="headers">
        <template v-slot:item.actions="{ item }">
          <v-btn icon text @click.prevent="select(item)">
            <v-icon>mdi-arrow-right-bold</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.date="{ item }">
          <span>{{ item.date | dateFormat }}</span>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>
<script>
import userAccessMixin from "../../../../mixins/userAccessMixin";
// import eventBus from "../../../../events/eventBus";
const API_ENDPOINT = "/api/empClearance";
export default {
  metaInfo: {
    title: "Employee Clearance Approval",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  data: () => ({
    classPadding: "my-0 py-0",
    statuses: [
      { text: "All", value: "" },
      { text: "Approved", value: "APPROVED" },
      { text: "Declined", value: "DECLINED" },
      { text: "Pending", value: "PENDING" },
      { text: "Waiting", value: "WAITING" }
    ],
    status: "",
    searchByItems: [
      { text: "Employee Name", value: "empName" },
      { text: "Transaction No", value: "ecfNo" },
      { text: "Status", value: "status" },
      { text: "Date Created", value: "createdDate" }
    ],
    searchBy: "empName",
    items: [],
    headers: [
      { text: "", value: "actions", sortable: false },
      { text: "Transaction No", value: "ecfNo" },
      { text: "Created Date", value: "date" },
      { text: "Employee Name", value: "fullName" },
      { text: "Order", value: "approverOrder" },
      { text: "Status", value: "status" }
    ],
    search: null
  }),
  methods: {
    triggerSearch() {
      var data = {
        status: this.status,
        searchCategory: this.searchBy,
        searchValue: this.search
      };
      this.$axios
        .post(`${API_ENDPOINT}/approval`, data)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    select(item) {
      // eventBus.$emit("SELECTED_PRF_STATUS", item.status);
      this.$router.push(
        `/emp-clearance-approval/${item.ecfNo}?status=${item.status}`
      );
    }
  },
  created() {
    this.triggerSearch();

    this.getUserAccessRights("ECAPPROVE");
  },
  watch: {
    status() {
      this.triggerSearch();
    }
  }
};
</script>
